import React, { Component } from 'react'
import '../styles/index.scss'
import { Pagination, message } from 'antd'
import BatchInfo from './BatchInfo'
import BatchTable from './data/BatchTable'
import BatchPartner from './BatchPartner'
import queryString from 'query-string'
import BatchHistory from "./history/BatchHistory"
import BatchFilters from './BatchFilters'
import BatchActions from './BatchActions'
import { informationBatches, listItemBatches, isAllowedRecycle, getListFailePieces, detectDownloadFile, bulkMergeBatches, getListSku, getSameEmbroideryDesignOrders } from "../../../services/api/3dApi"
import _ from 'lodash'
import OrdersSameInfoNotDesign from './OrdersSameInfoNotDesign'

class BatchPage extends Component {
    constructor(props) {
        super(props)

        const { location } = props.history

        let params = {}
        if (location.search !== '') {
            params = queryString.parse(location.search)
        }

        this.state = {
            batch: {},
            items: [],
            filters: {
                status: params.status || '',
                item_overtime: '',
                orderBy: 'printed_qr_at',
                orderSortType: 'desc',
            },
            limit: 50,
            page: 1,
            total: 0,
            loading: false,
            errorBatch: '',
            errorBatchItem: '',
            baseUrl: 'https://tool3d-partner.merch8.com',
            loadingShare: false,
            isOpen: false,
            urlBatchPartner: '',
            changeContent: false,
            showButton: false,
            error: '',
            listBatchPieceError: [],
            data: {},
            dataType: {},
            listBarcode: [],
        }
    }

    componentDidMount() {
        this._fetchBatch()
        this._fetchBatchItems()
        this._fetchButton()
        this._fetchBatchPieceError()
        this._detectDownloadFile()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this._fetchBatch()
            this._fetchBatchItems()
        }
    }

    _fetchBatchPieceError = async () => {
        try {
            const paload = {
                page: 1,
                limit: 1000
            }
            const { data: response } = await getListFailePieces(paload)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                listBatchPieceError: data.batches || [],
                errorBatch: ''
            })

        } catch (e) {
            this.setState({
                errorBatch: e.message
            })
        }
    }

    _fetchBatch = async () => {
        try {
            const { id } = this.props.match.params

            const { data: response } = await informationBatches(id)

            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                batch: data,
                errorBatch: ''
            })
        } catch (e) {
            this.setState({
                errorBatch: e.message
            })
        }
    }

    _fetchBatchItems = async () => {
        this.setState({
            loading: true
        })

        try {
            const { limit, page, filters } = this.state
            const { id } = this.props.match.params

            const params = {
                limit,
                page: parseInt(page, 0),
                getLastSewingGroup: 1,
                ...filters
            }

            let rqUrl = `limit=${params.limit}&page=${params.page}&getLastSewingGroup=${params.getLastSewingGroup}`

            if (params.status) {
                rqUrl += `&status=${params.status}`
            }

            if (params.type) {
                rqUrl += `&type=${params.type}`
            }

            if (params.item_overtime !== '') {
                rqUrl += `&item_overtime=${params.item_overtime}`
            }
            if (!!params.orderBy) {
                rqUrl += `&orderBy=${params.orderBy}&orderType=${params.orderSortType}`
            }

            if (params.printed_qr) {
                rqUrl += `&printed_qr=${params.printed_qr}`
            }

            const { data: response } = await listItemBatches(id, rqUrl)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            const { items, total } = data

            this.setState({
                total,
                items: items,
                loading: false,
                errorBatchItem: ''
            }, () => {
                this.fetchDataType()
            })
        } catch (e) {
            this.setState({
                loading: false,
                errorBatchItem: e.message
            })
        }
    }

    _fetchButton = async () => {
        try {
            const { id } = this.props.match.params

            const { data: response } = await isAllowedRecycle(id)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                showButton: data,
                error: ''
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    fetchDataType = async () => {
        try {
            const { items } = this.state
            const listProductType = [...new Set(items.map(order => order.product_type))]
            const dataType = {}
            await Promise.all(listProductType.map(async productType => {
                try {
                    const { data: res } = await getListSku({ sku: [productType] })
                    const { data } = Object.assign({}, res)
                    const { items = [] } = Object.assign({}, data)

                    dataType[productType] = !!items.length ? items[0] : {}

                } catch (error) {
                    console.log(error)
                }
            }))
            this.setState({ 
                dataType 
            }, () => {
                this._fetchListBarcode()
            })

        } catch (error) {
            console.error(error)
        }
    }

    _fetchListBarcode = async () => {
        const { items, dataType } = this.state

        const hasSKUTheu = Object.values(dataType).some(item => {
            return item.production_process?.name?.toLowerCase() === 'thêu';
        });

        // check Product thêu thì call api get barcode
        if (!hasSKUTheu) {
            return
        }

        try {
            const payload = {
                orders: items.map(orderItem => orderItem.item._id)
            }
            
            const {data: response} = await getSameEmbroideryDesignOrders(payload)
            const {data, success, message} = response

            if (!success) {
                throw new Error(message)
            }
            
            this.setState({
                listBarcode: data,
                error: ''
            })
        } catch (e) {
            this.setState({
                error: e.message
            })
        }
    }

    _handlePageChange = (current) => {
        this.setState({
            page: current
        }, this._fetchBatchItems)
    }

    _handleChangeStatus = (name, value) => {

        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    [name]: value
                },
                page: 1
            }
        }, this._fetchBatchItems)
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, this._fetchBatchItems)
    }

    _showModal = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _changeShowHistory = () => {
        this.setState({
            changeContent: !this.state.changeContent
        })
    }


    _refreshBatchInfo = async () => {
        await this._fetchBatch()
        await this._fetchBatchItems()
    }

    _handleSort = (field, value) => {
        const { filters } = this.state
        const { orderBy, orderSortType } = { ...filters }
        if (field === orderBy) {
            if (orderSortType === 'asc') {
                this.setState(({ filters }) => {
                    return {
                        filters: {
                            ...filters,
                            orderSortType: 'desc',
                        },
                        page: 1
                    }
                }, this._fetchBatchItems)
            }
            if (orderSortType === 'desc') {
                this.setState(({ filters }) => {
                    return {
                        filters: {
                            ...filters,
                            orderSortType: 'asc',
                        },
                        page: 1
                    }
                }, this._fetchBatchItems)
            }
            return
        }

        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    orderBy: field,
                    orderSortType: 'desc',
                },
                page: 1
            }
        }, this._fetchBatchItems)
    }

    _detectDownloadFile = async () => {
        try {
            const { id } = this.props.match.params
            const { data: response } = await detectDownloadFile(id)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({ data })
        } catch (error) {
            message.error(error.message)
        }
    }

    _actionSendMerge = async (need_convert_cmyk = false, location = '', non_cmyk) => {
        const { batch } = this.state
        this.setState({
            loading: true
        })

        try {
            const payload = {
                list_batch_id: [_.get(batch, '_id')],
                need_convert_cmyk,
            }

            if (!!location) payload.location = location
            if (non_cmyk !== undefined) payload.non_cmyk = non_cmyk

            const { data: response } = await bulkMergeBatches(payload)
            const { success, data, error } = response

            if (!success) {
                return message.error(error)
            }
            const { failed } = data
            if (failed.length > 0) {
                return message.error(failed[0])
            }

            this._refreshBatchInfo()
            message.success('Lô đã chuyển sang trạng thái "pending" để bắt đầu quá trình xử lý file.')
        } catch (e) {
            message.error(e.message)
        } finally {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        const { match, history } = this.props
        const {
            total,
            page,
            items,
            errorBatch,
            errorBatchItem,
            filters,
            limit,
            loading,
            batch,
            isOpen,
            urlBatchPartner,
            changeContent,
            error,
            showButton,
            listBatchPieceError,
            data,
            dataType,
            listBarcode
        } = this.state
        const { id } = this.props.match.params
        const { statistic_data, status: status_batch } = batch
        const isShowButtonPieceError = listBatchPieceError.some(item => item._id === id)

        return (
            <div className="BatchPage py-3">
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm p-3'>
                        {
                            listBarcode.length > 0 &&
                            <div className='mb-3 d-flex justify-content-end'>
                                <OrdersSameInfoNotDesign listBarcode={listBarcode}/>
                            </div>
                        }

                        {
                            batch.hasOwnProperty('_id') &&
                            <BatchInfo 
                                error={errorBatch} 
                                batch={batch} 
                                refreshBatchInfo={this._refreshBatchInfo} 
                                total={total} 
                                reload={this._fetchBatch}
                                data={data}
                                onActionSendMerge={this._actionSendMerge}
                                loading={loading}
                            />
                        }

                        <BatchPartner isOpen={isOpen} urlBatchPartner={urlBatchPartner} showModal={this._showModal} />

                        <div className='jumbotron p-3 mb-0'>
                            <div className="row align-items-end justify-content-between">
                                <div className='col-12 col-xl-auto'>
                                    {
                                        !changeContent &&
                                        <BatchFilters statistic={statistic_data || {}} filters={filters}
                                            onChangeStatus={this._handleChangeStatus} />
                                    }
                                </div>
                                <div className="col-12 col-xl-auto text-right">
                                    {
                                        error && <div className='text-danger mb-2'>{error}</div>
                                    }
                                    <BatchActions
                                        data={data}
                                        batch={batch}
                                        status={filters.status}
                                        changeContent={changeContent}
                                        match={match}
                                        history={history}
                                        showButton={showButton}
                                        refreshBatchInfo={this._refreshBatchInfo}
                                        onShowHistory={this._changeShowHistory}
                                        isShowButtonPieceError={isShowButtonPieceError}
                                        onActionSendMerge={this._actionSendMerge}
                                        loading={loading}
                                    />
                                </div>
                            </div>
                        </div>

                        {!changeContent ?
                            <div className='DetailBatches'>
                                <div
                                    className='d-flex justify-content-between align-items-center mb-0 py-3 headPagination'>
                                    <div>{errorBatchItem && <div className='text-danger'>{errorBatchItem}</div>}</div>
                                    <Pagination current={page} total={total} pageSize={limit}
                                        showTotal={(sum, range) => sum > 0 &&
                                            <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                            </div>}
                                        onChange={this._handlePageChange}
                                        className='text-right' showSizeChanger
                                        pageSizeOptions={['10', '20', '50', '100']}
                                        onShowSizeChange={this._handleShowSizeChange} />
                                </div>

                                <BatchTable
                                    filters={filters}
                                    orders={items}
                                    loading={loading}
                                    reloadItems={this._fetchBatchItems}
                                    handleSort={this._handleSort}
                                    statusBatch={status_batch}
                                    batch={batch}
                                    dataType={dataType}
                                />

                                <Pagination current={page} total={total} pageSize={limit}
                                    onChange={this._handlePageChange}
                                    className='text-right' showSizeChanger
                                    showQuickJumper
                                    pageSizeOptions={['10', '20', '50', '100']}
                                    onShowSizeChange={this._handleShowSizeChange} />
                            </div> :
                            <div className='History'>
                                <BatchHistory idBatch={id} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default BatchPage
